/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Is_LockedInputs */

const en_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project is Locked`)
};

const fr_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le projet est verrouillé`)
};

const de_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt ist gesperrt`)
};

const it_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il progetto è bloccato`)
};

const ru_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект заблокирован`)
};

const es_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proyecto está bloqueado`)
};

const zh_cn2_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目已锁定。`)
};

const ja_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトはロックされています`)
};

const hi_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट लॉक है`)
};

const pt_pt2_project_is_locked = /** @type {(inputs: Project_Is_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O projeto está bloqueado.`)
};

/**
* | output |
* | --- |
* | "Project is Locked" |
*
* @param {Project_Is_LockedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_is_locked = /** @type {((inputs?: Project_Is_LockedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Is_LockedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_is_locked(inputs)
	if (locale === "de") return de_project_is_locked(inputs)
	if (locale === "it") return it_project_is_locked(inputs)
	if (locale === "ru") return ru_project_is_locked(inputs)
	if (locale === "es") return es_project_is_locked(inputs)
	if (locale === "zh-CN") return zh_cn2_project_is_locked(inputs)
	if (locale === "ja") return ja_project_is_locked(inputs)
	if (locale === "hi") return hi_project_is_locked(inputs)
	if (locale === "pt-PT") return pt_pt2_project_is_locked(inputs)
	return en_project_is_locked(inputs)
});